import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js";
import { getWorkshopLoadData } from "../../Api/Api";
import { useNotification } from "../Notification/NotificationContext";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const WorkshopLoadChart = ({ workshopId }) => {
    const [chartData, setChartData] = useState(null);
    const { showNotification } = useNotification();

    useEffect(() => {
        const fetchData = async () => {
            try {
                getWorkshopLoadData(workshopId)
                    .then((response) => {
                        transformData(response.data);
                    })
                    .catch((error) => {
                        showNotification(error.message, "error");
                    });
            } catch (error) {
                showNotification(error.message, "error");
            }
        };

        fetchData();
    }, [workshopId]);

    const transformData = (data) => {
        if (!data.length) {
            setChartData(null);
            return;
        }

        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);
        const jobCounts = Array(24).fill(0).map(() => Array(7).fill(0));

        data.forEach(({ hourOfDay, dayOfWeek, jobCount }) => {
            jobCounts[hourOfDay][dayOfWeek - 1] = jobCount;
        });

        const datasets = jobCounts.map((jobs, hour) => ({
            label: hours[hour],
            data: jobs,
            backgroundColor: jobs.map((count) =>
                `rgba(60, 80, 224, ${Math.min(0.15 + count / 20, 0.8)})`
            ),
            barThickness: 8,
        }));

        setChartData({
            labels: daysOfWeek,
            datasets,
        });
    };

    return (
        <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-6 mt-10">
            <div className="mb-4 flex items-center justify-between">
                <h4 className="text-base font-semibold text-slate-700">Workshop Load Chart</h4>
            </div>

            {chartData ? (
                <div className="overflow-x-auto">
                    <Bar
                        data={chartData}
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: { display: false },
                                title: {
                                    display: true,
                                    text: "Peak Job Inflow by Hour & Day",
                                    font: { size: 16 },
                                    color: "#334155",
                                },
                            },
                            scales: {
                                x: {
                                    title: {
                                        display: true,
                                        text: "Day of the Week",
                                        color: "#64748b",
                                    },
                                    ticks: { color: "#64748b" },
                                },
                                y: {
                                    title: {
                                        display: true,
                                        text: "Number of Jobs",
                                        color: "#64748b",
                                    },
                                    ticks: { color: "#64748b" },
                                },
                            },
                        }}
                        height={400}
                    />
                </div>
            ) : (
                <p className="text-gray-500">No data available</p>
            )}
        </div>
    );
};

export default WorkshopLoadChart;
